import * as THREE from 'three'
import GUI from 'lil-gui'
//import gsap from 'gsap'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import testVertexShader from './shaders/vertex.glsl'
import testFragmentShader from './shaders/fragment.glsl'

/**
 * Debug
 */
//const gui = new GUI()


const parameters = {
    materialColor: '#fdbaef'
}

// gui
//     .addColor(parameters, 'materialColor')
//     .onChange(() =>
//     {
//         console.log(parameters.materialColor)
//         material.color.set(parameters.materialColor)
//     })

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}


// Scene
const scene = new THREE.Scene()

// Texture
const textureLoader = new THREE.TextureLoader()
const particleTexture = textureLoader.load('/textures/particles/11.png')
const gradientTexture = textureLoader.load('textures/gradients/3.jpg')
gradientTexture.magFilter = THREE.NearestFilter

//Material
const material = new THREE.MeshToonMaterial({ 
    gradientMap: gradientTexture,
    color: parameters.materialColor 
})


/**
 * Objects
 */

const gltfLoader = new GLTFLoader()
let sakuraModel = null
const sakuraMaterial = new THREE.MeshPhongMaterial() 
gltfLoader.load(
'/model/stylized_cherry_blossom_flower/scene.gltf',
(gltf) =>
{
    console.log('success')
    console.log(gltf)
    sakuraModel = gltf.scene.children[0].children[0].children[0].children[0]
    console.log(sakuraModel)
    sakuraModel.scale.set(0.3,0.3,0.3)
    //const testObj = new THREE.Mesh(sakuraModel, sakuraMaterial)
    //console.log(testObj)
    //testObj.scale.set(3,3,3)
    //scene.add(testObj)
},
(progress) =>
{
    console.log('progress')
    console.log(progress)
},
(error) =>
{
    console.log('error')
    console.log(error)
}

)



const spiralGroup = new THREE.Group()
scene.add(spiralGroup)
const objCount = 150
//const objPos = new Float32Array(objCount*3)


// const objGeometry = new THREE.BufferGeometry()
// objGeometry.setAttribute('position', new THREE.BufferAttribute(objPos, 3))

// Points
// const spiral = new THREE.Points(objGeometry, material)
// scene.add(spiral)



// const mesh2 = new THREE.Mesh(
//     new THREE.ConeGeometry(1, 2, 32),
//     material
// )
// const mesh3 = new THREE.Mesh(
//     new THREE.TorusKnotGeometry(0.8, 0.35, 100, 16),
//     material
// )
// const sectionMeshes = [ mesh1, mesh2, mesh3 ]
// scene.add(mesh1, mesh2, mesh3)
console.log(sizes.width)
const geometry = new THREE.PlaneGeometry(sizes.width/100, sizes.height/100, 64, 64)

/**
 * Shaders
 */



const simpleShader = new THREE.ShaderMaterial(
    {
        vertexShader: testVertexShader,
        fragmentShader: testFragmentShader,
        uniforms:
        {
            uFrequency: { value: new THREE.Vector2(10, 5) },
            uTime: { value: 0 },
            uColor: { value: new THREE.Color('orange') },
            u_resolution: { type: "v2", value: new THREE.Vector2(sizes.width, sizes.height) }
//            uTexture: { value: flagTexture }
        },
        transparent: true

    }
)


const mesh = new THREE.Mesh(geometry, simpleShader)
//mesh.scale.y = 2 / 3
//mesh.scale.y = sizes.height/ 2000
//mesh.scale.x = sizes.width / 2000
console.log("height: " + sizes.height)
console.log("width: " + sizes.width)
//mesh.position.x = -0.7
mesh.position.z = -3
scene.add(mesh)

/**
 * Lights
 */
const directionalLight = new THREE.DirectionalLight('#ffffff', 3)
directionalLight.position.set(1, 1, 0)
scene.add(directionalLight)
const ambientLightSource = new THREE.AmbientLight( 0xffffff ); // soft white light
scene.add( ambientLightSource );



 const objectsDistance = 4
// mesh1.position.y = - objectsDistance * 0
// mesh2.position.y = - objectsDistance * 1
// mesh3.position.y = - objectsDistance * 2

// mesh1.position.x = 2
// mesh2.position.x = - 2
// mesh3.position.x = 2


window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

//Scroll
let scrollY = window.scrollY
window.addEventListener('scroll', () =>
{
    scrollY = window.scrollY
    const newSection = Math.round(scrollY / sizes.height)

    // if(newSection != currentSection)
    // {
    //     currentSection = newSection

    //     console.log('changed', currentSection)
    //     gsap.to(
    //         sectionMeshes[currentSection].rotation,
    //         {
    //             duration: 1.5,
    //             ease: 'power2.inOut',
    //             x: '+=6',
    //             y: '+=3',
    //             z: '+=1.5'
    //         }
    //     )
    // }
})



/**
 * Cursor
 */
const cursor = {}
cursor.x = 0
cursor.y = 0

window.addEventListener('mousemove', (event) =>
{
    cursor.x = event.clientX / sizes.width - 0.5
    cursor.y = event.clientY / sizes.height - 0.5

})


/*
* Particles
*/
// const particlesCount = 200
// const positions = new Float32Array(particlesCount * 3)
// for(let i = 0; i < particlesCount; i++)
// {
//     positions[i * 3 + 0] = (Math.random() - 0.5) * 10
//     positions[i * 3 + 1] = objectsDistance * 0.5 - Math.random() * objectsDistance * window.height
//     positions[i * 3 + 2] = (Math.random() - 0.5) * 10
// }
// const particlesGeometry = new THREE.BufferGeometry()
// particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))

// Material
// const particlesMaterial = new THREE.PointsMaterial({
//     color: parameters.materialColor,
//     sizeAttenuation: true,
//     size: 0.6
// })
// particlesMaterial.map = particleTexture
// particlesMaterial.transparent = true
// particlesMaterial.alphaMap = particleTexture
// particlesMaterial.depthWrite = false
// // Points
// const particles = new THREE.Points(particlesGeometry, particlesMaterial)
// scene.add(particles)




/**
 * Camera
 */

const cameraGroup = new THREE.Group()
scene.add(cameraGroup)

// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 6
cameraGroup.add(camera)

// Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0
let currentSection = 0
let sakuraAdded = false
const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

     // Update material
    simpleShader.uniforms.uTime.value = elapsedTime

    if(sakuraModel != null && !sakuraAdded) {
        for(let i = 0; i < objCount; i++) {
        // objPos[i*3 + 0] = Math.sin(i*3)
        // objPos[i*3 + 1] = i*3
        // objPos[i*3 + 2] = Math.cos(i*3)
        const mesh1 = sakuraModel.clone()/*new THREE.Mesh(
        new THREE.SphereGeometry( 0.03, 16, 8 ),
        material
        )*/
        const factor = 0.1
        const xyfactor = 0.2
        mesh1.position.x = Math.sin((i-15)/4) *Math.PI * 0.5 * xyfactor*5 +Math.random()     //Helix: Math.sin(i*3) *factor*5
        mesh1.position.y = 1.8-i*3*factor              //Helix: 1.5-i*3*factor
        mesh1.position.z = Math.cos((i-15)/4)*xyfactor*5  *Math.PI * 0.5     //Helix: Math.cos(i*3)*factor*5 
        mesh1.rotation.x = Math.random() * Math.PI *2 
        mesh1.rotation.z = Math.random() * Math.PI *2 
        //console.log(mesh1)//.materialColor("pink")
        spiralGroup.add(mesh1)
        }
        spiralGroup.position.x += 1.5
        console.log(spiralGroup)
        sakuraAdded = true
    }


    //Animate meshes
    // for(const mesh of spiralGroup)
    // {
    //     //spiralGroup.rotation.x += deltaTime * 0.1
        
    // }

    for (let i = 0; i < spiralGroup.children.length; i++) {
        spiralGroup.children[i].rotation.z += deltaTime * 0.6 +(Math.random()-0.5)*0.01
        spiralGroup.children[i].rotation.x += deltaTime * 0.6 + (Math.random()-0.5)*0.01
    }

    // if(sakuraModel !== null ){
    //     sakuraModel.rotation.x += deltaTime * 0.01
    //     sakuraModel.rotation.y += deltaTime * 0.01
    //     sakuraModel.rotation.z += deltaTime * 0.01
    // }

    spiralGroup.rotation.y += deltaTime * 0.3
    // Animate camera
    camera.position.y = - scrollY / sizes.height 
    mesh.position.y = - scrollY / sizes.height

    const parallaxX = cursor.x
    const parallaxY = - cursor.y
    cameraGroup.position.x += (parallaxX - cameraGroup.position.x) * 5 * deltaTime
    cameraGroup.position.y += (parallaxY - cameraGroup.position.y)* 5 *deltaTime
    mesh.position.x += (parallaxX - cameraGroup.position.x) * 5 * deltaTime
    mesh.position.y += (parallaxY - cameraGroup.position.y)* 5 *deltaTime

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()